module.exports = __webpack_public_path__ + "img/Atlasofemotion_1.d95e75df.png";